import { setSpecificMessage, notValue } from "valibot";
setSpecificMessage(
  notValue,
  (issue) => `Valeur invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);